import React from 'react';
import './fold.css';

const Fold4 = () => {
  const features = [
    {
      title: "Real-time Outbound Calls",
      description: "24/7, scalable, multilingual.",
      icon: "📞"
    },
    {
      title: "Cart Context Awareness",
      description: "Items, prices, user name dynamically pulled from Shopify.",
      icon: "🛒"
    },
    {
      title: "Conversational AI",
      description: "Handles questions, understands objections, escalates complex issues.",
      icon: "🤖"
    },
    {
      title: "Live Incentives",
      description: "Tailor discount codes on the fly.",
      icon: "🎯"
    },
    {
      title: "SMS Integration",
      description: "Send links + codes directly in the conversation.",
      icon: "💬"
    },
    {
      title: "Analytics Dashboard",
      description: "Call logs, recovery rates, AOV uplift.",
      icon: "📊"
    },
    {
      title: "Compliance Built-in",
      description: "AI disclosure, opt-out mechanics, GDPR/CCPA ready.",
      icon: "🔒"
    }
  ];

  return (
    <div className="fold-content">
      <div className="features-container">
        <div className="section-header">
          <h2 className="section-title">Why Choose Beanbag AI?</h2>
          <p className="section-subtitle">Core Features</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`feature-box ${index < 4 ? 'first-row' : 'second-row'}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Fold4;